module.exports = __webpack_public_path__ + "static/media/ic_wallet_to_wallet_transfer.68cabcaf.png";